import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'

const Popup = () => {
  const [popupClosed, setPopupClosed] = useState(false)

  useEffect(() => {
    const isPopupClosed = Cookies.get('popupClosed')
    if (isPopupClosed) {
      setPopupClosed(true)
    }
  }, [])

  const handleClose = () => {
    setPopupClosed(true)
    Cookies.set('popupClosed', 'true', { expires: 1 / 144 }) // Popup won't reappear for 10 minutes
  }

  return (
    <>
      <div
        className={`fixed top-0 left-0 w-full h-full bg-orange/95 z-30 text-white ${popupClosed === true ? `hidden` : `block`}`}
      >
        <button
          className="text-2xl absolute right-3 top-3 text-white hover:text-blue"
          onClick={handleClose}
        >
          x
        </button>
        <div className="container mx-auto flex justify-center w-full h-full mt-20">
          <div className="max-w-[30rem]">
            <div className="border-white rounded-2xl border-2 bg-blue shadow-2xl p-9">
              <p className="rfs:text-[3rem] font-secondary font-bold">Limited Time Offer!</p>
              <p className="font-bold rfs:text-[2rem]">
                Free Service Agreement with any repair over $90!
              </p>
              <p className="font-bold mt-4 rfs:text-[1.5rem]">Includes 2 checkups:</p>
              <ul>
                <li>1 Heating Tune-Up</li>
                <li>1 Cooling Tune-Up</li>
              </ul>

              <a
                href="tel:2152710682"
                className="flex relative justify-center content-center uppercase gap-4 w-full rounded-lg border-2 text-white hover:text-gray-darker border-orange-light bg-orange-light hover:bg-white hover:border-white mt-4 max-w-[16rem]"
              >
                <p className="z-10 inline-block text-center !m-auto font-[900] rfs:text-[2.05875rem] lg:rfs:text-[1.5rem] !py-3 !px-5">
                  Call Now
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { Popup }
